module.exports = __webpack_public_path__ + "static/media/6-7.8e69c26e.mp3";